export const routes = {
  ACCOUNT_SETTINGS: '/account-settings',
  ACCOUNT: '/account',
  ADCREATION_STEP: '/3',
  AUDIENCE_STEP: '/2',
  BROWSE_ADS: '/browse-ads',
  BROWSE_ADS_ADVIEW: '/ad/:id',
  BUILD_AD: '/build-ad',
  CAMPAIGN_STEP: '/1',
  CREATIVE_GUIDELINES: '/creative-guidelines',
  FAQ: '/faq',
  FEEDBACK: '/feedback',
  LOGIN: '/login',
  LOGOUT: '/logout',
  MAIN: '/',
  NOT_FOUND: '*',
  SIGNUP: '/signup',
  TERMS: '/terms',
  BETA_TERMS: '/beta-terms',
  WAITLIST: '/waitlist',
  REDIRECT: '/redirect',
};

export const routeStrings = createRouteStrings();

function createRouteStrings() {
  const newRoutes = {};
  for (const key in routes) {
    if (routes[key].length > 1) {
      newRoutes[key] = routes[key].slice(1, routes[key].length);
    } else {
      newRoutes[key] = routes[key];
    }
  }

  return newRoutes;
}



// WEBPACK FOOTER //
// ./src/config/routes.js